import React from "react";
import PropTypes from "prop-types";
import "./WelcomeScreen.scss";

const WelcomeScreen = ({ question }) => {
  return (
    <div className="welcome-screen">
      {question.title && (
        <h2 className="welcome-screen__title">{question.title}</h2>
      )}
      {question.description && (
        <div className="welcome-screen__description">
          <p>{question.description}</p>
        </div>
      )}
    </div>
  );
};

WelcomeScreen.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default WelcomeScreen;
